import '@css/main.css'
import * as Sentry from '@sentry/browser'
import Alpine from 'alpinejs'

import './_parts/quick-search'
import './archive/overview'
import './_utilities/alpine'
import './_parts/analytics'
import './_parts/aria-expanded'
import './_parts/button-hover'
import './_parts/mailchimp'
import './_parts/nav'
import './_parts/formie-course-select'
import './_parts/reveal'
import './_parts/sidebar-spy'


Alpine.start()

requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        document.documentElement.classList.remove('no-transitions')
    })
})

if (import.meta.env.PROD) {
    Sentry.init({
        dsn: 'https://6d1219d57ce06f6b9a69eab7e57e31d9@o4507408422993920.ingest.de.sentry.io/4511569643176016',

        release: `dosign-academy@${import.meta.env.VITE_COMMIT_HASH}`,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 0.2,

        // Ignore noise from bots and third-party scripts
        ignoreErrors: [
            // Microsoft Outlook SafeLinks crawler
            /Object Not Found Matching Id:\d+/,
        ],

        // Ignore errors thrown by third-party scripts and browser extensions
        denyUrls: [
            /cdn\.leadinfo\.net/,
            /consent\.cookiebot\.eu/,
            /^chrome-extension:\/\//,
            /^moz-extension:\/\//,
            /^safari(-web)?-extension:\/\//,
        ],

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/search\.test\.dosign-academy\.nl\.kiwicloud\.nl/,
            /^https:\/\/search\.accept\.dosign-academy\.nl\.kiwicloud\.nl/,
            /^https:\/\/search\.dosign-academy\.nl/,
        ],

        // Capture Replay for 2% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.02,
        replaysOnErrorSampleRate: 1.0,
    })
}

// Parts
const videos = document.querySelectorAll<HTMLElement>('.video__wrapper')
if (videos) {
    import('./_parts/video').then((module) => {
        new module.default(videos)
    })
}

const popup = document.getElementById('popup')
if (popup) {
    import('./_parts/popup').then((module) => {
        new module.default()
    })
}

// Blocks
const imagesSliders = document.querySelectorAll<HTMLElement>('.images-slider')
if (imagesSliders) {
    import('./_blocks/images').then((module) => {
        new module.default(imagesSliders)
    })
}

const reviewSliders = document.querySelectorAll<HTMLElement>('.review-slider')
if (reviewSliders) {
    import('./_blocks/reviews').then((module) => {
        new module.default(reviewSliders)
    })
}

const memberSlider = document.querySelectorAll<HTMLElement>('.member-slider')
if (memberSlider) {
    import('./_blocks/members').then((module) => {
        new module.default(memberSlider)
    })
}

const logoSliders = document.querySelectorAll<HTMLElement>('.logo-slider')
if (logoSliders.length) {
    import('./_blocks/logo-slider').then((module) => {
        new module.default(logoSliders)
    })
}

const doorwaySliders = document.querySelectorAll<HTMLElement>('.doorways-slider')
if (doorwaySliders.length) {
    import('./_blocks/doorways').then((module) => {
        new module.default(doorwaySliders)
    })
}

const casesDoorwaySliders = document.querySelectorAll<HTMLElement>('.cases-doorway-slider')
if (casesDoorwaySliders.length) {
    import('./_blocks/cases-doorway').then((module) => {
        new module.default(casesDoorwaySliders)
    })
}
